import { apiCallGetReportByID } from "../../api/report-api/api-call-get-report-by-id";
import { parseConversationData } from "../../helpers/et3-conversation-parse";
import getCorePopUpStore from "../core/core-popup-store";
import getCoreUIStore from "../core/core-ui-store";
import getReportsStore from ".";
import { getReportsByType } from "./get-reports-by-type";
import { getPendingReports } from "./get-pending-reports";
import { getAndAddDaysToSpecifiedTime } from "../../helpers/et3-date-helper";
import { isDefinedString, reduce } from "et3-type-guards";
import { DEFAULT_REPORT_OBJECT } from "../../constants/input-entries-constants";
import { apiCallGetPendingReportsByUserID } from "../../api/report-api/api-call-get-pending-reports-by-user-id";
import getCoreHistoryStore from "../core/core-history-store";
import getUserAdvancedStore from "../user-store/advanced-store";

export const getReportByIDFromDatabase = async (id: number) => {
  getCoreUIStore().setIsLoading("REPORTS", true);
  const { status, data, code } = await apiCallGetReportByID(id);
  getCoreUIStore().setIsLoading("REPORTS", false);
  const reports = data.map((report) => {
    report.conversation = parseConversationData(report.conversation);
    return report;
  });
  if (status === "OK") {
    const reportData = reduce(() => reports[0], DEFAULT_REPORT_OBJECT);
    const nextDayDate = getAndAddDaysToSpecifiedTime(reportData.reportedOn, 1);
    getReportsStore().fromDate.set(new Date(reportData.reportedOn));
    getReportsStore().toDate.set(new Date(nextDayDate));
    getReportsStore().setReportStatus({
      label: reportData.status,
      value: reportData.status
    });
    getReportsStore().setReportsByType(reports);
  } else {
    getCorePopUpStore().showAlertMessage(code);
  }
};
export const getReportByUserIDFromDatabase = async (userID: number) => {
  getCoreUIStore().setIsLoading("REPORTS", true);
  const { data, status, code } = await apiCallGetPendingReportsByUserID({
    userID
  });
  getCoreUIStore().setIsLoading("REPORTS", false);

  if (status === "OK") {
    const userReports = reduce(() => data.userReports, {});
    const pool = reduce(() => data.pool, "");
    if (isDefinedString(pool)) {
      getUserAdvancedStore().setAdminPoolTable(pool);
      getCorePopUpStore().openConfirmationPopUps(
        "CLEAN_POOL_CONFIRMATION_POPUP"
      );
    } else {
      const reportedIds = Object.keys(userReports);
      const firstReport = userReports[reportedIds[0]].data[0];
      const isReportIndonesianMalaysian =
        firstReport.isReportIndonesianMalaysian;
      reportedIds.forEach((reportedId) => {
        userReports[reportedId].data.map((report) => {
          report.conversation = parseConversationData(report.conversation);
          return report;
        });
      });
      getReportsStore().setPendingReports(userReports);
      getReportsStore().setReportStatus({
        label: "Pending",
        value: "pending"
      });
      !isReportIndonesianMalaysian
        ? getReportsStore().setReportCreatedFromType({
            label: "Other",
            value: "Other"
          })
        : getReportsStore().setReportCreatedFromType({
            label: "Indonesia/Malaysia",
            value: "indonesia_malaysia"
          });
      getCoreHistoryStore().openNewTab(`/reports?userID=${userID}`);
    }
  } else {
    getCorePopUpStore().showAlertMessage(code);
  }
};
const getReportsFromDatabase = async (withURLSearch: boolean) => {
  const reportsStore = getReportsStore();
  const pendingReports = reportsStore.status.get().value === "pending";
  reportsStore.cleanReports();
  if (pendingReports) {
    return await getPendingReports(withURLSearch);
  } else {
    return await getReportsByType();
  }
};
export default getReportsFromDatabase;
